import classNames from 'classnames';
import React, { useState } from 'react';
import { Col, Row } from 'reactstrap';
import { CheckboxButton } from '../../../../../../../components/CheckboxButton';
import { Select, SelectOption } from '../../../../../../../components/Select';
import { SurveyQuestionFieldType } from '../../../../../../../entities/survey_engine/SurveyQuestionFieldType';
import styles from './styles.module.scss';

interface PropTypes {
  title: string;
  placeholder: string;
  selected: SurveyQuestionFieldType;
  mandatory: boolean;
}

const QUESTION_TYPE_TO_FIELD_TYPE_MAP = {
  [SurveyQuestionFieldType.Attachment]: 'Import file',
  [SurveyQuestionFieldType.Email]: 'Email address',
  [SurveyQuestionFieldType.Phone]: 'Phone number',
  [SurveyQuestionFieldType.Text]: 'Open text',
  [SurveyQuestionFieldType.Url]: 'URL',
  [SurveyQuestionFieldType.Location]: 'Location',
  [SurveyQuestionFieldType.Boolean]: 'Boolean',
  [SurveyQuestionFieldType.MultiOptions]: 'Multi Options',
};

function toLowerCaseUnderscore(value?: string) {
  return value?.toLowerCase()?.replace(' ', '');
}

function mapToSelectOption(
  label: string,
  selectedValue?: SelectOption,
): SelectOption {
  return {
    value: toLowerCaseUnderscore(label),
    label: label,
    selected: toLowerCaseUnderscore(label) === selectedValue?.value,
  };
}

export function ApplicationFormTemplateRow(props: PropTypes) {
  const [inputType, setInputType] = useState<SelectOption>(
    mapToSelectOption(QUESTION_TYPE_TO_FIELD_TYPE_MAP[props.selected]),
  );
  const [mandatory, setMandatory] = useState(props.mandatory);

  return (
    <div className={classNames('w-75', styles['application-form-row'])}>
      <Row className='mb-2'>
        <Col xs='6'>
          <label className='label fw-semibold'>{props.title}</label>
        </Col>
        <Col xs='3'>
          <label className='label fw-semibold'>Input Type</label>
        </Col>
        <Col xs='3'></Col>
      </Row>
      <Row>
        <Col xs='6'>
          <input
            className={classNames('form-control', 'fs-5')}
            type='text'
            placeholder={props.placeholder}
            disabled={true}
          />
        </Col>
        <Col xs='3'>
          <Select
            options={Object.values(QUESTION_TYPE_TO_FIELD_TYPE_MAP).map(
              (value: string) => mapToSelectOption(value),
            )}
            onChange={(value) => setInputType(value)}
            selected={inputType}
            disabled={true}
          />
        </Col>
        <Col xs='3' className='align-self-center'>
          <CheckboxButton
            name={props.title}
            label={'Mandatory Field'}
            checked={mandatory}
            disabled={true}
            onChange={() => setMandatory(!mandatory)}
          />
        </Col>
      </Row>
    </div>
  );
}
